import { ele } from "cables-shared-client";

export default class PageErrorReport
{
    constructor(targetElement)
    {
        const locationHash = window.location.hash.split("#")[1];
        if (locationHash)
        {
            const elError = ele.byId(locationHash);
            if (elError)
            {
                ele.toggle(elError);
                elError.scrollIntoView({ "block": "center" });
            }
        }

        const allErrorTabs = ele.byQueryAll(".errordata .tab-bar li");
        allErrorTabs.forEach((tab) =>
        {
            tab.addEventListener("click", () =>
            {
                const errorId = tab.dataset.id;
                const tabName = tab.dataset.tabName;
                const tabs = ele.byQueryAll("#error" + errorId + " .tab-bar li");
                tabs.forEach((t) => { t.classList.remove("active"); });
                tab.classList.add("active");

                const contents = ele.byQueryAll("#error" + errorId + " .content");
                contents.forEach((content) => { content.classList.add("hidden"); });
                const content = ele.byQuery("#error" + errorId + " .content." + tabName);
                content.classList.remove("hidden");
            });
        });
    }
}
